import { HttpRequest, HttpHandlerFn, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from '../services/session.service';

export function sessionHttpInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const sessionService = inject(SessionService);

  // Add credentials to all requests
  const authReq = req.clone({
    withCredentials: true
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle session-related errors
      if (error.status === 401) {
        console.log('HTTP 401 - Unauthorized, handling session expiration');
        //sessionService.logout().subscribe();
        return throwError(() => error);
      }
      
      if (error.status === 403) {
        console.log('HTTP 403 - Forbidden');
        // Let the session service handle 403 errors
        return throwError(() => error);
      }

      // For other errors, just pass them through
      return throwError(() => error);
    })
  );
}
